import { render, staticRenderFns } from "./PkgStdRiskTxt.vue?vue&type=template&id=6f7376de&"
import script from "./PkgStdRiskTxt.vue?vue&type=script&lang=js&"
export * from "./PkgStdRiskTxt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports